<template>
    <div
        class="col-lg-3 hidden-md-down minicart-wrap"
        data-element="minicart-wrap"
        ref="wrap"
    >
        <div
            class="minicart-cont"
            data-element="minicart"
            ref="cart"
        >
            <slot name="miniCart"></slot>
            <slot name="portingForm"></slot>
            <slot name="nowBuying"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "Aside",
}
</script>

<style scoped></style>